import React, {Component} from 'react';
import PropTypes from 'prop-types';

import {topoUtils} from '../utils/topo-utils';
import {geoUtils} from '../utils/geo-utils';

class StateOutline extends Component {

  shouldComponentUpdate(nextProps){
    const widthDifferent = nextProps.width !== this.props.width;
    const heightDifferent = nextProps.height !== this.props.height;
    const stateDifferent = nextProps.stateFips !== this.props.stateFips;

    return widthDifferent || heightDifferent || stateDifferent;
  }

  render() {
    const topo = topoUtils.getStateTopography(this.props.stateFips);
    const path = geoUtils.getAlbersStatePath(this.props.stateFips, this.props.width, this.props.height);

    return (
      <g className="StateOutline">
        <path d={path(topo.land)}></path>
      </g>
    )
  }
}

StateOutline.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  stateFips: PropTypes.number
};

export default StateOutline


// WEBPACK FOOTER //
// ./src/charts/Map/StateOutline.js